// Tutorial 3: Managing Users
// Shown to admins after Tutorial 2

export const TUTORIAL_KEY = 'user_management';

export const steps = [
  {
    id: 'howUsersJoin',
    title: 'How Your Team Joins',
    icon: '👥',
    content: 'Team members get access by logging in with Salesforce from your org. We automatically detect they\'re from your org and create an access request.',
    bullets: [
      "You'll see pending requests in the Admin panel",
    ],
  },
  {
    id: 'approving',
    title: 'Approving Access',
    icon: '✓',
    content: 'When someone requests access, you can:',
    bullets: [
      'Approve - they get member access',
      'Reject - they\'re denied (with optional reason)',
    ],
  },
  {
    id: 'roles',
    title: 'Roles',
    icon: '🎭',
    content: 'Approved users can view analytics and dashboards. Only admins can:',
    bullets: [
      'Change sync settings',
      'Approve other users',
      'Manage visualizations and dashboards',
    ],
  },
  {
    id: 'done',
    title: "You're Ready to Go!",
    icon: '✅',
    content: 'Share your workspace with your team. When they log in with Salesforce, you\'ll see their request in the Admin panel.',
  },
];

export default { TUTORIAL_KEY, steps };
